<template>
  <md-dialog class="user-pass-form-dialog" :md-closed="closeDialog" :md-opened="openDialog" :md-close-on-esc="false"
             :md-click-outside-to-close="false"
             :md-active.sync="options.showchangePW">

    <md-dialog-title class="ml-30 mt-20" style="font-size: 2rem;">
      <div class="tab-header-grid">
        <div class="tab-title">
          {{ options.Lang.account_title }}
        </div>
        <div class="tab-info-box">
        </div>
        <div class="tab-info-box">
          <SmallInfoBox :title="options.Lang.account_user + ':'" :content="`${options.user.firstname} ${options.user.lastname}`" />
        </div>
      </div>
      <div class="tab-buttons">
        <button class="tab-btn" :class="{ active: tabChoice === 'password_change'}" @click="tabChoice = 'password_change'">
          {{ options.Lang.Passwort_ändern }}
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'language_change'}" @click="tabChoice = 'language_change'">
          {{ options.Lang.Sprache }}
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'security'}" @click="tabChoice = 'security'; loadTotpStatus();">
          {{ options.Lang.security_tab }}
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'profile_pic'}" @click="tabChoice = 'profile_pic'">
          {{ options.Lang.Profilbild || 'Profilbild' }}
        </button>
      </div>
    </md-dialog-title>
    <md-dialog-content>
      <transition name="tab-slide-fade" mode="out-in" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave" @leave="leave" @after-leave="afterLeave">
      <div :key="tabChoice">

      <div v-if="tabChoice === 'password_change'" style="min-height: 200px;">
        <div style="display: flex;">
          <div class="user-pass-change-input">
            <md-field class="md-focused">
              <label for="password">{{ options.Lang.neues_Passwort }}</label>
              <md-input tabindex="5" name="password" autocomplete="off" placeholder="*********" type="password" id="password" v-model="form.newPassword"/>
            </md-field>
          </div>
          <div class="user-pass-change-input">
            <md-field class="md-focused">
              <label for="password">{{options.Lang.neues_Passwort_wiederholen}}</label>
              <md-input tabindex="5" name="password" autocomplete="off" placeholder="*********" type="password"
                        id="passwordnew"
                        v-model="form.confirmPassword"
              />
            </md-field>
          </div>
        </div>
      </div>
      <div v-if="tabChoice === 'language_change'" style="min-height: 200px;">
        <div style="display: flex;">
          <md-field class="md-focused user-pass-change-select" style="width: 50% !important; margin: auto !important; margin-top: 20px !important;">
            <label for="sprache">{{ options.Lang.Sprache_wählen }}</label>
            <md-select tabindex="3" name="sprache" id="sprache" v-model="sprache" @input="changeLang" md-dense>
              <md-option value="German">{{options.Lang.Deutsch}}</md-option>
              <md-option value="Englisch">{{options.Lang.Englisch}}</md-option>
              <md-option value="French">{{options.Lang.French}}</md-option>
              <md-option value="Dutch">{{options.Lang.Dutch}}</md-option>
              <md-option value="Greek">{{options.Lang.Greek}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

      <div v-if="tabChoice === 'security'" class="security-tab">
        <!-- Status bar -->
        <div class="security-status" :class="{ 'security-status--active': totpEnabled }">
          <md-icon>{{ totpEnabled ? 'verified_user' : 'security' }}</md-icon>
          <span>{{ options.Lang.two_factor_auth }}: <strong>{{ totpEnabled ? options.Lang['2fa_enabled'] : options.Lang['2fa_disabled'] }}</strong></span>
        </div>

        <transition name="security-step" mode="out-in">
        <div :key="securityStep">

        <!-- Setup: initial state -->
        <div v-if="!totpEnabled && !totpSetupActive" class="security-setup-initial">
          <div class="security-setup-col">
            <h4 style="margin: 0 0 8px;">{{ options.Lang['2fa_setup_title'] }}</h4>
            <p style="color: #666; margin: 0; line-height: 1.4;">
              {{ options.Lang['2fa_setup_description'] }}
            </p>
          </div>
          <div class="security-setup-col">
            <md-button class="md-raised md-primary" @click="startTotpSetup">{{ options.Lang['2fa_setup_button'] }}</md-button>
          </div>
        </div>

        <!-- Setup: QR code step -->
        <div v-if="totpSetupActive && !totpSetupVerified" class="security-setup-initial">
          <div class="security-setup-col">
            <h4 style="margin: 0 0 8px;">{{ options.Lang['2fa_qr_title'] }}</h4>
            <p style="color: #666; margin: 0 0 12px; line-height: 1.4;">
              {{ options.Lang['2fa_qr_description'] }}
            </p>
            <div style="background: #F5F6FA; padding: 10px 14px; border-radius: 6px; margin-bottom: 20px; word-break: break-all; width: 100%;">
              <span style="font-size: 0.8rem; color: #999; display: block; margin-bottom: 4px;">{{ options.Lang['2fa_manual_key'] }}</span>
              <code style="font-size: 0.95rem; letter-spacing: 1px;">{{ totpManualKey }}</code>
            </div>
            <p style="color: #666; margin: 0 0 8px; font-size: 0.9rem; width: 100%;">{{ options.Lang['2fa_enter_code'] }}</p>
            <div style="display: flex; align-items: flex-end; gap: 10px; width: 100%;">
              <md-field class="md-focused" style="flex: 1; max-width: 200px;">
                <label>{{ options.Lang['2fa_code_label'] }}</label>
                <md-input v-model="totpSetupCode" maxlength="6" placeholder="000000" @keyup.enter="verifyTotpSetup"/>
              </md-field>
            </div>
            <div style="display: flex; gap: 8px; margin-top: 16px; width: 100%;">
              <md-button class="md-raised md-primary" @click="verifyTotpSetup" :disabled="totpSetupCode.length < 6">{{ options.Lang['2fa_confirm'] }}</md-button>
              <md-button class="md-raised secondary" @click="cancelTotpSetup">{{ options.Lang['2fa_cancel'] }}</md-button>
            </div>
          </div>
          <div class="security-setup-col">
            <div class="security-qr">
              <img :src="totpQrCode" alt="QR Code"/>
            </div>
          </div>
        </div>

        <!-- Recovery codes -->
        <div v-if="totpSetupVerified && showRecoveryCodes" class="security-setup-initial">
          <div class="security-setup-col">
            <h4 style="margin: 0 0 8px; color: #e65100;">{{ options.Lang['2fa_recovery_title'] }}</h4>
            <p style="color: #666; margin: 0 0 12px; line-height: 1.4;">
              {{ options.Lang['2fa_recovery_description'] }}
              <strong>{{ options.Lang['2fa_recovery_warning'] }}</strong>
            </p>
            <md-button class="md-raised md-primary" @click="showRecoveryCodes = false; totpSetupVerified = false; totpSetupActive = false;">
              {{ options.Lang['2fa_recovery_saved'] }}
            </md-button>
          </div>
          <div class="security-setup-col">
            <div class="security-recovery-codes">
              <div v-for="(code, index) in recoveryCodes" :key="index" class="security-recovery-code">
                {{ code }}
              </div>
            </div>
          </div>
        </div>

        <!-- Disable: initial -->
        <div v-if="totpEnabled && !totpDisableActive" class="security-setup-initial">
          <div class="security-setup-col">
            <h4 style="margin: 0 0 8px;">{{ options.Lang['2fa_active_title'] }}</h4>
            <p style="color: #666; margin: 0; line-height: 1.4;">
              {{ options.Lang['2fa_active_description'] }}
            </p>
          </div>
          <div class="security-setup-col">
            <md-button class="md-raised" style="background: #e65100; color: white;" @click="totpDisableActive = true">
              {{ options.Lang['2fa_disable'] }}
            </md-button>
          </div>
        </div>

        <!-- Disable: confirm -->
        <div v-if="totpDisableActive" class="security-disable-layout">
          <div class="security-disable-row">
            <div class="security-setup-col">
              <h4 style="margin: 0 0 8px;">{{ options.Lang['2fa_disable_title'] }}</h4>
              <p style="color: #666; margin: 0; line-height: 1.4;">
                {{ options.Lang['2fa_disable_description'] }}
              </p>
            </div>
            <div class="security-setup-col">
              <md-field class="md-focused" style="max-width: 200px;">
                <label>{{ options.Lang['2fa_code_label'] }}</label>
                <md-input v-model="totpDisableCode" maxlength="6" placeholder="000000" @keyup.enter="disableTotp"/>
              </md-field>
            </div>
          </div>
          <div class="security-disable-row security-disable-btn-row" style="margin-top: 24px;">
            <div class="security-setup-col">
              <md-button class="md-raised secondary security-disable-btn" @click="totpDisableActive = false; totpDisableCode = '';">{{ options.Lang['2fa_cancel'] }}</md-button>
            </div>
            <div class="security-setup-col">
              <md-button class="md-raised security-disable-btn" style="background: #e65100; color: white;" @click="disableTotp">{{ options.Lang['2fa_disable'] }}</md-button>
            </div>
          </div>
        </div>
        </div>
        </transition>
      </div>

      <div v-if="tabChoice === 'profile_pic'" style="min-height: 200px; padding: 16px 24px;">
        <div class="profile-pic-tab">
          <!-- same round uploader as the user form (parts/AvatarUpload.vue);
               Save sends the draft, remove sends null -->
          <AvatarUpload
              v-model="profilePicModel"
              :disabled="profilePicSending"
              :label="options.Lang.Account_Logo"
              :upload-label="options.Lang.user_pic_upload"
              :change-label="options.Lang.user_pic_change"
              :remove-label="options.Lang.user_pic_remove"
              :drop-label="options.Lang.user_pic_drop"
              :hint="options.Lang.user_pic_hint"
              @error="onPicError"
          />
        </div>
      </div>
      </div>
      </transition>

      <!--////////-->
      <Error class="errorDialog" v-if="options.showError && options.user.loggedIn"
                   :options="options"></Error>  
      <Success class="errorDialog" v-if="options.showSuccess && options.user.loggedIn"
                   :options="options"></Success>  
    </md-dialog-content>
    <md-dialog-actions class="tab-actions-border">
      <md-button tabindex="8" class="md-raised secondary" @click="closeDialog"><strong>{{ options.Lang.close_window }}</strong></md-button>
      <md-button v-if="tabChoice === 'password_change'" tabindex="7" class="md-raised md-primary user-pass-change-button" @click="changeMeCheck()"><strong>{{options.Lang.Passwort_ändern}}</strong></md-button>
      <md-button v-if="tabChoice === 'profile_pic'" tabindex="7" class="md-raised md-primary user-pass-change-button" :disabled="!profilePicDirty || profilePicSending" @click="saveProfilePic"><strong>{{ options.Lang.Speichern || 'Speichern' }}</strong></md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import * as moment from 'moment'
import {validationMixin} from 'vuelidate'
import {Editor, EditorContent} from '@tiptap/vue-2'
import Success from "@/components/dialogs/Success";

import Error from './Error.vue'
import SmallInfoBox from '@/components/parts/SmallInfoBox.vue'
import heightFadeTransition from '@/mixins/heightFadeTransition'
import AvatarUpload from '../parts/AvatarUpload.vue'
export default {
  name: 'changePW',
  mixins: [validationMixin, heightFadeTransition],
  components: {
    Error,
    Success,
    SmallInfoBox,
    AvatarUpload,
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    trip: null,
    sprache: null,
    tabChoice: 'password_change',
    form :{
      newPassword: '',
      confirmPassword: ''
    },
    totpEnabled: false,
    totpSetupActive: false,
    totpSetupVerified: false,
    totpQrCode: '',
    totpManualKey: '',
    totpSetupCode: '',
    showRecoveryCodes: false,
    recoveryCodes: [],
    totpDisableActive: false,
    totpDisableCode: '',
    profilePicData: null,   // draft (data URL) or null = remove; meaningful only while dirty
    profilePicDirty: false,
    profilePicSending: false
  }),
  computed: {
    // v-model for AvatarUpload: the saved picture until the user changes it,
    // then the draft (a new data URL, or null after "remove").
    profilePicModel: {
      get() {
        return this.profilePicDirty ? this.profilePicData : (this.options.user.pic || null);
      },
      set(value) {
        this.profilePicData = value;
        this.profilePicDirty = true;
      }
    },
    securityStep() {
      if (this.totpSetupVerified && this.showRecoveryCodes) return 'recovery';
      if (this.totpSetupActive) return 'qr';
      if (this.totpDisableActive) return 'disable-confirm';
      if (this.totpEnabled) return 'active';
      return 'setup';
    }
  },
  created() {
  },
  mounted() {
    this.getLang();
  },
  watch: {
  },
  methods: { 
    async getLang(){
      let self = this;
      await self.doPost({ data: self.options.user }, 'getLangUser', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
            self.sprache = res.data.data[0].lang
        }
      });
    },
    moment(date){
      return moment(date)
    },
    async changeLang() {
      switch (this.sprache) {
        case "Englisch":
          this.options.Lang = this.options.Englisch;
          this.$i18n.locale = 'en'
          break;
        case "French":
          this.options.Lang = this.options.French;
          this.$i18n.locale = 'fr'
          break;
        case "Dutch":
          this.options.Lang = this.options.Dutch;
          this.$i18n.locale = 'nl'
          break;
        case "Greek":
          this.options.Lang = this.options.Greek;
          this.$i18n.locale = 'el'
          break;
        default:
          this.options.Lang = this.options.German;
          this.$i18n.locale = 'de'
          break;
      }
      this.options.successMsg = this.options.Lang.Erfolgreich;
      this.options.errorMsg = this.options.Lang.Upps;
      this.options.showDelete = this.options.Lang.Bild_löschen;
      this.options.user.lang = this.sprache;
      let LangData = {
        user: this.options.user,
        lang: this.sprache,
      }
      let self = this;
      await self.doPost({data: LangData}, 'setLangUser', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        }
      });
    },
    changeMeCheck(){
      if(this.form.newPassword == '' || this.form.confirmPassword == '' || this.form.newPassword != this.form.confirmPassword){
        this.options.showError = true;
      }else{
        this.changeMe();
      }
    },
    changeMe(){
      let pwdata = {
        user: this.options.user,
        pw: this.form.newPassword
      }
      let self = this;
      self.doPost({ data: pwdata }, 'changePwUser', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
            self.options.showSuccess = true;
        }
      });
    },
    parseDate(date){
      return moment(date).format('DD. MMM HH:mm');
    },
    openDialog() {
    },
    closeDialog() {
      // an unsaved picture draft is discarded with the dialog
      this.profilePicData = null;
      this.profilePicDirty = false;
      this.options.showchangePW = false;
      //location.reload()
    },
    refreshDialog() {
      let self = this;
      self.options.showchangePW = false;
      self.$nextTick(() => {
        self.options.showchangePW = true;
      });
    },
    onPicError(key) {
      this.showErrorMsg(this.options.Lang[key] || this.options.Lang.user_request_failed);
    },
    saveProfilePic() {
      if (!this.profilePicDirty) return;
      const self = this;
      self.profilePicSending = true;
      self.doPost({
        userdata: self.options.user,
        data: { id: self.options.user.id, pic: self.profilePicData }
      }, 'updateUserById', function (res) {
        self.profilePicSending = false;
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.user.pic = self.profilePicData;
          // Also push the new pic into the Vuex store so vuex-persistedstate writes it to
          // localStorage. Otherwise on reload the stale cached user shadows the DB value.
          const storedUser = Object.assign({}, self.$store.getters.getUser, { pic: self.profilePicData });
          self.$store.dispatch('checkout', { user: storedUser });
          self.options.showSuccess = true;
          self.profilePicData = null;
          self.profilePicDirty = false;
        }
      });
    },
    async loadTotpStatus() {
      let self = this;
      await self.doPost({ userdata: self.options.user, data: {} }, 'totp-status', function (res) {
        if (res.status === 'ok' && res.data) {
          self.totpEnabled = res.data.totpEnabled;
        }
      });
    },
    async startTotpSetup() {
      let self = this;
      await self.doPost({ userdata: self.options.user, data: { company: process.env.VUE_APP_COMPANY || '' } }, 'totp-setup', function (res) {
        if (res.status === 'ok' && res.data) {
          self.totpQrCode = res.data.qrCode;
          self.totpManualKey = res.data.manualKey;
          self.totpSetupActive = true;
        } else {
          self.showErrorMsg(res.msg || self.options.Lang['2fa_invalid_code']);
        }
      });
    },
    async verifyTotpSetup() {
      let self = this;
      await self.doPost({ userdata: self.options.user, data: { totpCode: self.totpSetupCode } }, 'totp-verify-setup', function (res) {
        if (res.status === 'ok' && res.data && res.data.recoveryCodes) {
          self.totpSetupVerified = true;
          self.totpEnabled = true;
          self.recoveryCodes = res.data.recoveryCodes;
          self.showRecoveryCodes = true;
        } else {
          self.showErrorMsg(res.msg || self.options.Lang['2fa_invalid_code']);
        }
      });
    },
    cancelTotpSetup() {
      this.totpSetupActive = false;
      this.totpSetupVerified = false;
      this.totpQrCode = '';
      this.totpManualKey = '';
      this.totpSetupCode = '';
    },
    async disableTotp() {
      let self = this;
      await self.doPost({ userdata: self.options.user, data: { totpCode: self.totpDisableCode } }, 'totp-disable', function (res) {
        if (res.status === 'ok') {
          self.totpEnabled = false;
          self.totpDisableActive = false;
          self.totpDisableCode = '';
          self.options.showSuccess = true;
          self.options.successMsg = self.options.Lang['2fa_disabled_success'];
        } else {
          self.showErrorMsg(res.msg || self.options.Lang['2fa_invalid_code']);
        }
      });
    },
  },
  }
</script>
<style lang="scss">
@use '../../assets/style/General/tab_layout.scss';
.tab-slide-fade-enter-active,
.tab-slide-fade-leave-active {
  overflow: hidden;
}
.tab-slide-fade-enter,
.tab-slide-fade-leave-to {
  transform: none !important;
}

.security-step-enter-active,
.security-step-leave-active {
  transition: opacity 0.25s ease;
}
.security-step-enter,
.security-step-leave-to {
  opacity: 0;
}

.security-tab {
  padding: 16px 24px;
  min-height: 520px;
}
.security-setup-initial {
  display: flex;
  min-height: 300px;
  align-items: center;
}
.security-disable-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 300px;
  justify-content: center;
}
.security-disable-row {
  display: flex;
  width: 100%;
  align-items: center;
}
.security-disable-btn-row .security-setup-col {
  display: flex;
  justify-content: center;
}
.security-disable-btn {
  width: 180px !important;
  min-width: 180px !important;
  margin: 0 !important;
}
.security-setup-col {
  margin: auto;
  &:first-child {
    width: 50%;
  }
  &:last-child {
    width: 20%;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0;
  h4, p {
    text-align: left;
    width: 100%;
  }
}
.security-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 16px;
  background: #F5F6FA;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 1rem;
  .md-icon { color: #999; margin: 0 !important; flex-shrink: 0; }
  &--active {
    background: #e8f5e9;
    .md-icon { color: #4caf50; }
  }
}
.security-content {
  display: flex;
  gap: 28px;
  align-items: flex-start;
  &--centered {
    align-items: center;
    min-height: 340px;
  }
}
.security-left {
  flex: 1;
  min-width: 0;
}
.security-right {
  flex: 0 0 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.security-placeholder {
  width: 160px;
  height: 160px;
  background: #F5F6FA;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  .md-icon {
    margin: 0 !important;
    width: 56px !important;
    min-width: 56px !important;
    height: 56px !important;
    font-size: 56px !important;
  }
}
.security-qr {
  img {
    display: block;
    width: 190px;
    height: 190px;
  }
}
.security-recovery-codes {
  background: #F5F6FA;
  padding: 16px 20px;
  border-radius: 8px;
  font-family: monospace;
  font-size: 1rem;
  letter-spacing: 1px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
}
.security-recovery-code {
  padding: 4px 0;
}
.md-field.md-has-password .md-toggle-password{
  margin: 0;
}
.imgRemove{
  margin-top: 5px;
  background-color: rgb(253, 217, 223);
  text-align: center;
}
.imgRemove:hover{
  cursor: pointer;
}
.imgchoice{
  min-height: 100px;
  min-width: 150px;
  max-width: 150px;
  max-height: 100px;
}
.dialog{
  width: 100%;
}
.imgContainer{
  display: flex;
}

.imgContainer img:hover{
  cursor: pointer;
}
.showMail{
  position: absolute;
  min-width: 900px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  background: white;
  padding: 50px;
  overflow-y: auto;
}
.tableclass{
  width: 100%;
  min-height: 70px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}

.tableclass:hover{
  cursor: pointer;
}
.tableclass2{
  width: 100%;
  min-height: 30px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;

}
.tableclass td{
  padding: 5px;
  vertical-align: top;
}

.tableclass2 td{
  padding: 5px;
  vertical-align: top;
}

.tableclass tr{
  padding: 5px;
  background-color: rgb(243, 243, 243);
}
.spacer{
  background-color: white;
  height: 5px;
}
.name{
  width: 10%;
}

.date{
  width: 10%;
}

.trip-details{
  width: 30%;
}

.address1{
  width: 15%;
}

.address2{
  width: 20%;
}

.cc{
  width: 15%;
}
.minH{
  min-height: 50px;
}

.none{
  display: none;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #B6D210;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #B6D210 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading_spinner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000000000;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.catTR td{
  background-color: white;
}
.user-pass-change-button{
  float: inline-end;
}
.user-pass-change-input{
  display: flex;
  width: 35%;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: auto;
}
.user-pass-form-dialog .md-dialog-container{
  width: 900px !important;
  margin: 0 auto;
  border-radius: 12px;
}
.profile-pic-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 20px;
}
.md-field .md-toggle-password {
  position: absolute !important;
  right: 8px !important;
  bottom: 10px !important;
  top: auto !important;
  transform: none !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.md-field .md-toggle-password .md-ripple {
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.md-field .md-toggle-password .md-icon {
  margin: 0 !important;
}
</style>